import React from "react";
import { useState } from "react";
import { Input } from "reactstrap";
import { FormControl } from "@mui/material";

import StationInfoCard from "../components/info_cards/station_info_card"; 
import LocationCard from "../components/card_order/location_card";
import { gas_types, demo_stations } from "../constants/common";
import RadioGroupCustom from "../components/radio_group_chip";
import ButtonGroupCustom from "../components/button_group";
import CustomMap from "../components/map/custom_map";
import SwitchCustom from "../components/switch";

// TODO:
// 1. Table filter by gas - DONE
// 2. Map filter by gas - DONE
// 3. Filter by location
const GasStations = () => {
  const [showMap, setShowMap] = useState(false);
  const [active, setActive] = useState(0);
  const [selectedGas, setSelectedGas] = useState("Бүгд");
  const [selectedService, setSelectedService] = useState("Бүгд");
  const [stations, setStations] = useState([...demo_stations]);
  const [selectedStation, setSelectedStation] = useState();
  const [filteredStations, setFilteredStations] = useState(stations);

  function clearFilter() {
    setSelectedGas("Бүгд");
    setSelectedService("Бүгд");
  }

  function filterStation(value) {
    setSelectedGas(value);
    if (value == "Бүгд") {
      setFilteredStations(stations);
    } else {
      const result = stations.filter((station) =>
        station.available_gases.includes(value)
      );
      setFilteredStations(result);
    }
  }

  return (
    <div className="">
      <div className="d-flex pt-3 pb-3 align-items-center px-0 px-sm-4 px-xxl-5">
        <div className="card-info-dialog ms-3">
          <ButtonGroupCustom
            active={active}
            setActive={setActive}
            items={["ШТС -ууд", "Нэмэлт үйлчилгээ "]}
          />
        </div>
        <SwitchCustom
          value={showMap}
          handleChange={(value) => setShowMap(value.target.checked)}
        />
        <div>Газрын зургаар харах</div>
      </div>
      <div className="divider mb-3" />
      <div className="px-0 px-sm-4 px-xxl-5">
        <div className="d-lg-flex justify-content-between align-content-center d-none">
          <div className="d-flex flex-wrap gap-2">
            <div className="select custom-select">
              <Input
                className="py-2 px-3 custom-dropdown"
                type="select"
                placeholder=""
                defaultValue="Хот, Аймаг"
              >
                <option value="Хот, Аймаг" disabled>
                  Хот, Аймаг
                </option>
              </Input>
            </div>
            <div className="select custom-select">
              <Input
                className="py-2 px-3 custom-dropdown"
                type="select"
                placeholder=""
                defaultValue={"Дүүрэг, Сум"}
              >
                <option className="text-disabled" value="Дүүрэг, Сум" disabled>
                  Дүүрэг, Сум
                </option>
              </Input>
            </div>
            <div className="select custom-select">
              <Input
                className="py-2 px-3 custom-dropdown"
                type="select"
                placeholder=""
                defaultValue={"Баг, Хороо"}
              >
                <option className="text-disabled" value="Баг, Хороо" disabled>
                  Баг, Хороо
                </option>
              </Input>
            </div>
          </div>
          <p
            className="my-auto text-grey pointer font-weight-500 font-size-14"
            onClick={clearFilter}
          >
            Шүүлтүүр устгах
          </p>
        </div>
        <div className="mt-3 me-2">
          <FormControl>
            {active == 0 ? (
              <RadioGroupCustom
                value={selectedGas}
                setValue={(val) => filterStation(val)}
                options={["Бүгд", ...gas_types]}
              />
            ) : (
              <RadioGroupCustom
                value={selectedService}
                setValue={setSelectedService}
                options={["Бүгд", "Засвар", "Угаалга", "Авто дэлгүүр"]}
              />
            )}
          </FormControl>
        </div>
      </div>
      <div className="divider mt-3 mb-3" />
      <div className="mt-3 mb-4">
        {showMap ? (
          <CustomMap markers={filteredStations} />
        ) : (
          <div className="px-0 px-sm-4 px-xxl-5 me-2">
            <div className="row">
              <div className="col-7 border border-grey rounded">
                {active == 0 ? (
                  <div>
                    {filteredStations.map((station, index) => {
                      return (
                        <LocationCard
                          key={index}
                          station={station}
                          isBtnRight={false}
                          selected={selectedStation}
                          setSelected={setSelectedStation}
                        />
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {stations.map((station, index) => {
                      return <LocationCard key={index} station={station} />;
                    })}
                  </div>
                )}
              </div>
              <div className="col-5">
                {selectedStation && (
                  <StationInfoCard station={selectedStation} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GasStations;
